import { PayloadAction, createSlice, current } from '@reduxjs/toolkit';
import { nanoid } from 'nanoid';

const initialState = [] as Toast[];

const DEFAULT_TOAST = {
  type: 'error',
  time: 5000,
  showIcon: true,
  autoClose: true,
  closeOnClick: false,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    deleteToast: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload;

      if (current(state).length > 0) {
        return current(state).filter((toast) => toast?.id !== id);
      }

      return;
    },
    setToast: (state, action: PayloadAction<Toast>) => {
      const { id, description, ...rest } = action.payload;

      if (description && description.length != 0) {
        state.push({
          id: id || nanoid(),
          ...DEFAULT_TOAST,
          description,
          ...rest,
        });
      }
    },
  },
});

export const { setToast, deleteToast } = toastSlice.actions;

export default toastSlice.reducer;
